import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaCdt.mjs'
import Model from './ModelCdt.mjs'
import PropertiesPane from './PropertiesPaneCdt.jsx'
import FormChoose from './FormChooseCdt.jsx'
import TableChoose from './TableChooseCdt.jsx'
import api from './apiCdt.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        canMountType(map, node, type) {
            return 'CDTSEQVAL' === type
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'CDTSEQVAL'},
            ]
        },

        _getShape(map, node) {
            return 'EllipseRectangle'
        },

        _getThemeColor(map, node) {
            return Color.CYAN
        },

        _pushDataSlots: {
            children: [],
            dmCdtSeqVals: [],
        },
    })
}
